import { __rest, __assign } from '../node_modules/tslib/tslib.es6.esm.js';
import React__default, { forwardRef } from 'react';
import classNames from 'classnames';
import { checkValidLabel } from '../utils/accessibility.esm.js';
import NvLabel from '../NvLabel/NvLabel.esm.js';
import styles from './NvTextArea.module.esm.js';

var NvTextArea = forwardRef(function (_a, ref) {
    var _b;
    var placeholder = _a.placeholder, _c = _a.id, id = _c === void 0 ? 'nv-text-area' : _c, error = _a.error, onChange = _a.onChange, onFocus = _a.onFocus, value = _a.value, classes = _a.classes, hideLabel = _a.hideLabel, label = _a.label, helperText = _a.helperText, props = __rest(_a, ["placeholder", "id", "error", "onChange", "onFocus", "value", "classes", "hideLabel", "label", "helperText"]);
    checkValidLabel(label, id);
    var getClassName = function () {
        var root = error ? styles.error : styles.inputGroup;
        // for case when we need to override the default class with the prop
        return classNames(root, classes ? classes.root : '');
    };
    var className = getClassName();
    return (React__default.createElement("div", { className: className, ref: ref },
        React__default.createElement(NvLabel, { className: styles.label, htmlFor: id, isHidden: hideLabel, value: label }),
        React__default.createElement("div", { className: error ? styles.error : styles.inputGroup },
            React__default.createElement("textarea", __assign({ "aria-label": label, id: id, onChange: onChange, onFocus: onFocus, placeholder: placeholder, value: value }, props))),
        helperText && (React__default.createElement("div", { className: classNames(styles.helperText, (_b = {},
                _b[styles.errorColor] = error,
                _b)) }, helperText))));
});
NvTextArea.displayName = 'NvTextArea';

export { NvTextArea as default };
//# sourceMappingURL=NvTextArea.esm.js.map
